// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 950px) {
  .navbar-desktop {
    display: none !important;
  }
}

@media (max-width: 1300px) {
  .nav-logo {
    height: 40px !important;
  }
  .navLink {
    font-size: 16px !important;
  }
}

.navbar-desktop {
  z-index: 20;
  width: 100vw;
  position: fixed;
  display: flex;
  padding: 16px 24px;
  justify-content: space-between;
  background-color: var(--dark);
}

.nav-logo {
  height: 60px;
}

.nav-links {
  display: flex;
  align-items: center;
}

.navLink {
  color: var(--light);
  font-family: "EB Garamond";
  font-weight: 600;
  font-size: 20px;
  padding: 2px 2px;
  margin: 6px 12px;
}

.currentNavLink {
  border-bottom: 1px solid var(--softyellow);
}

.dropdown {
  min-height: 40px; /* this needs to be the same as the top value on the dropdown-options */
  position: relative;
  display: flex;
  flex-direction: column;
  filter: var(--shadow);
}

.dropdown i {
  display: inline-block;
  margin-left: 10px;
}

.dropdown-options {
  padding: 16px;
  position: absolute;
  top: 40px; /* this needs to be the same as the min-height value on the .dropdown class */
  right: 8px;
  width: 200px;
  background-color: var(--light);
}

.dropdown-options ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown-options li {
  height: 32px;
}

.dropdown-options a {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  font-weight: 500;
  color: var(--dark);
}

.dropdown-options h3 {
  letter-spacing: 0.1rem;
  font-size: 0.75rem;
  margin: 8px 0;
  color: var(--dark);
  text-transform: uppercase;
}

.hidden {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/css/DesktopNavbar.css"],"names":[],"mappings":"AAAA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB,EAAE,uEAAuE;EACzF,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS,EAAE,6EAA6E;EACxF,UAAU;EACV,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf","sourcesContent":["@media (max-width: 950px) {\n  .navbar-desktop {\n    display: none !important;\n  }\n}\n\n@media (max-width: 1300px) {\n  .nav-logo {\n    height: 40px !important;\n  }\n  .navLink {\n    font-size: 16px !important;\n  }\n}\n\n.navbar-desktop {\n  z-index: 20;\n  width: 100vw;\n  position: fixed;\n  display: flex;\n  padding: 16px 24px;\n  justify-content: space-between;\n  background-color: var(--dark);\n}\n\n.nav-logo {\n  height: 60px;\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n}\n\n.navLink {\n  color: var(--light);\n  font-family: \"EB Garamond\";\n  font-weight: 600;\n  font-size: 20px;\n  padding: 2px 2px;\n  margin: 6px 12px;\n}\n\n.currentNavLink {\n  border-bottom: 1px solid var(--softyellow);\n}\n\n.dropdown {\n  min-height: 40px; /* this needs to be the same as the top value on the dropdown-options */\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  filter: var(--shadow);\n}\n\n.dropdown i {\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.dropdown-options {\n  padding: 16px;\n  position: absolute;\n  top: 40px; /* this needs to be the same as the min-height value on the .dropdown class */\n  right: 8px;\n  width: 200px;\n  background-color: var(--light);\n}\n\n.dropdown-options ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.dropdown-options li {\n  height: 32px;\n}\n\n.dropdown-options a {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  font-weight: 500;\n  color: var(--dark);\n}\n\n.dropdown-options h3 {\n  letter-spacing: 0.1rem;\n  font-size: 0.75rem;\n  margin: 8px 0;\n  color: var(--dark);\n  text-transform: uppercase;\n}\n\n.hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
